import {defineStore} from 'pinia'
import {reactive} from 'vue'

export const useResultPageStore = defineStore('resultPage', () => {
    const resultPage = reactive({
        jobs: [],
        openTabs: [],
        base64Images: [],
        settings: {},
        tools: null,
        isMobile: false,
        isMediumRes: false,
        isFullRes: true,
        activeToolGroup: 'all',
        image: '',
        mask: '',
        outputImage: '',
    })

    function getResultPage() {
        return resultPage.jobs;
    }

    function getJobs() {
        return resultPage.jobs;
    }

    function addJob(job) {
        resultPage.jobs.push(job);
    }

    function getJobById(id) {
        return resultPage.jobs.find(job => job.id === id);
    }

    function getOutputById(id, outputid) {
        let job = this.getJobById(id);

        return job.apiJob.output.find(output => output.id === outputid);
    }

    function getBase64(url) {
        return resultPage.base64Images.find(base64 => base64.url === url);
    }

    function addBase64(url, base64) {
        resultPage.base64Images.push({
            url: url,
            base64: base64,
        });
    }

    function getSettings() {
        return resultPage.settings;
    }

    function addTab(tab) {
        resultPage.openTabs.push(tab);
    }

    function getOpenTabs() {
        return resultPage.openTabs;
    }

    function updateSettings(settings) {
        resultPage.settings = settings;
    }

    return {
        resultPage,
        getResultPage,
        addTab,
        getOpenTabs,
        addJob,
        getJobs,
        getJobById,
        getOutputById,
        getSettings,
        updateSettings,
        getBase64,
        addBase64
    }
})